<template>
  <circle opacity="0.1" cx="27.5" cy="27.5001" r="27.5" fill="#4794F7" />
  <path
    d="M20 20.0001C20 18.8955 20.8954 18.0001 22 18.0001H34C35.1046 18.0001 36 18.8955 36 20.0001V36.0001C36 37.1046 35.1046 38.0001 34 38.0001H22C20.8954 38.0001 20 37.1046 20 36.0001V20.0001Z"
    fill="#2E63D6"
  />
  <rect x="25" y="22.0001" width="6" height="2" rx="1" fill="white" />
  <rect x="23" y="26.0001" width="10" height="2" rx="1" fill="#92AFEA" />
  <rect x="23" y="30.0001" width="10" height="2" rx="1" fill="#92AFEA" />
</template>
